import React from "react";

import svg from "../../assets/images/icons/not_contains.svg";

export const NotContainsIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Text Not Contains"}
    />
);
